<template>
    <span>
    <span v-if=tooltip :class="speed_class" v-tooltip="problem_title">
        <span v-if="speeds.length == 1" >
        {{ formatted_speeds }}
        </span>
        <span v-if="speeds.length == 2" :title="$t('commute.duration.depending-on-traffic')" >
        {{ formatted_speeds }}
        </span>
        <span v-html="speed_problem"></span>

    </span>
    
    <span v-if=!tooltip :class="speed_class">
        <span v-if="speeds.length == 1" >
        {{ formatted_speeds }}
        </span>
        <span v-if="speeds.length == 2" :title="$t('commute.duration.depending-on-traffic')" >
        {{ formatted_speeds }} 
        </span>
        <span v-html="speed_problem"></span> {{ problem_title }}

    </span>
    
    
    </span>
</template>

<script>
    import conversions from '../conversions.js'

    export default {
        props: {
            vehicle :  Object,
            
            dist : { // in km
              type: Number,
              default: 1
            },
            duration : { // in seconds
              type: Number,
              default: 1
            },
            duration_in_traffic : { // in seconds
              type: Number,
              default: NaN
            },
            tooltip : {
                type: Boolean,
                default : true
            }
        },
        computed : {
            speeds : function(){
                //console.log('speeds this.dist='+this.dist)
                let s = []
                let ds = this.durations
                s.push(this.speed(this.dist*1000, ds[0]/60))
                if(ds.length == 2){
                    s.push(this.speed(this.dist*1000, ds[1]/60))
                }       
                return s         
                
            },
            durations : function(){
                let d = this.duration
                if(!isNaN(this.duration_in_traffic)){
                    let dit = this.duration_in_traffic
                    if(dit > d
                    && (dit - d) > 60 // more than a minute difference
                    ){
                        return [d, dit]
                    }
                }
                return [d]
            },
            formatted_durations : function(){
                let ds = this.durations
                if(ds.length == 1){
                    return conversions.formatDuration(ds[0])
                }
                return conversions.formatDuration(ds[0])+" - "+conversions.formatDuration(ds[1])
            },
            formatted_speeds : function(){
                let s = this.speeds
                if(s.length == 1){
                    return conversions.formatSpeed(s[0])
                }
                return conversions.formatSpeedRange([s[1],s[0]])
            },
            speed_class : function(){
                if(this.speed_problem == ""){
                    return ""
                }
                return "speed_problem"
            },            
            speed_problem: function(){
                let s = this.speeds
                if(s.length == 1){
                    if(s[0] > this.vehicle['speed_ceiling']){
                        return this.too_fast() 
                    }
                    if(s[0] < this.vehicle['speed_floor']){
                        return this.too_slow() 
                    }
                }
                
                if(s[1] > this.vehicle['speed_ceiling']){
                    return this.too_fast() 
                }
                if(s[0] < this.vehicle['speed_floor']){
                    return this.too_slow() 
                }
                    
                return ""
            },
            problem_title: function(){
                let s = this.speeds
                if(s.length == 1){
                    if(s[0] > this.vehicle['speed_ceiling']){
                        return this.$t('speed.too-fast')
                    }
                    if(s[0] < this.vehicle['speed_floor']){
                        return this.$t('speed.too-slow')
                    }
                }
                
                if(s[1] > this.vehicle['speed_ceiling']){
                    return this.$t('speed.too-fast')
                }
                if(s[0] < this.vehicle['speed_floor']){
                    return this.$t('speed.too-slow')
                }
                    
                return ""
            }
        },
        methods : {
            too_fast : function(){
                return '<img src="icons/warning_18.png">'
            },
            too_slow : function(){
                return '<img src="icons/warning_18.png">'
            
            },
            speed : function(d,t){ //dist in m, time in minutes

                let s = (parseFloat(d)/1000) / (parseFloat(t) / 60) // kph
                //console.log("speed d="+d)
                //console.log("speed t="+t)
                //console.log("speed s="+s)
                return s
                
            },
            convert: function(fn, ...args){
                return conversions[fn](...args);
            },
        }

    }
    

</script>

<style>

span.speed_problem {
    color: red;
    font-weight: bold;
}

</style>